module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-d6f1fa23a955090033eb31b9abbf0b56.png";